import { InjectionToken } from '@angular/core';

export const VG_VOLUME_COMPONENT_TOKEN = new InjectionToken<any>(
	'VG_VOLUME_COMPONENT_TOKEN'
);
